export default "__VITE_ASSET__dcf3637b__"